import {Controller} from 'stimulus';

export default class extends Controller {
  static targets = ['items','areas', 'itemsTab', 'areasTab']

  connect() {
    if (this.isDesktop()) {
      return;
    }
    
    this.areasTarget.hidden = true;
    this.itemsTabTarget.classList.add("active");
  }

  selectAreasTab() {
    this.itemsTabTarget.classList.remove("active");
    this.areasTabTarget.classList.add("active");
    this.itemsTarget.hidden = true;
    this.areasTarget.hidden = false;
  }

  selectItemsTab() {
    this.itemsTabTarget.classList.add("active");
    this.areasTabTarget.classList.remove("active");
    this.itemsTarget.hidden = false;
    this.areasTarget.hidden = true;
  }

  isDesktop() {
    return window.innerWidth >= 768;
  }
}
